import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";

const PrwReCaptcha = (props: any) => {
  const { i18n } = useTranslation();

  return (
    <div>
      <ReCAPTCHA
        hl={i18n.language}
        sitekey={process.env.REACT_APP_RECAPTCHA_CLIENT_KEY || ""}
        onChange={(e: any) => props.onChange(e)}
      />
    </div>
  );
};

export default PrwReCaptcha;
